import noOp from "./noOp";
export { noOp as default, noOp as toClass };

//# sourceMappingURL=toClass.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/toClass.js
// module id = 64
// module chunks = 0